import {
  Button,
  Card,
  CardContent,
  FormControlLabel,
  Switch
} from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import { FormChange } from "@saleor/hooks/useForm";
import React, { FC, useCallback } from "react";

import { TooltipArrowLeft } from "../CouponDetails/Tooltip";
import { useStyles } from "./styles";

interface IEnableUnlockCodesCardProps {
  isEnabledUnlockCodes: boolean;
  onChange: FormChange;
  isCouponEditable: boolean;
  onSetCodesButtonClick: () => void;
}

const EnableUnlockCodesCard: FC<IEnableUnlockCodesCardProps> = ({
  isEnabledUnlockCodes,
  onChange,
  isCouponEditable,
  onSetCodesButtonClick
}) => {
  const classes = useStyles({});

  const onToggleEnableUnlockCodes = useCallback(
    (event: React.ChangeEvent<HTMLInputElement>) => {
      onChange({
        target: {
          name: "isCodeUnlocked",
          value: event.target.checked
        }
      });
    },
    [onChange]
  );

  return (
    <Card className={classes.cardContainer}>
      <CardContent className={classes.cardContentContainer}>
        <div className={classes.radioContainer}>
          <FormControlLabel
            control={
              <Switch
                color="primary"
                checked={isEnabledUnlockCodes}
                onChange={onToggleEnableUnlockCodes}
              />
            }
            label="Enable Unlock Codes"
            labelPlacement="end"
            disabled={!isCouponEditable}
            className={classes.styledFormControlLabel}
          />
          <TooltipArrowLeft
            title="Toggle this if coupon requires an Unlock code."
            placement="right"
          >
            <InfoOutlined color="primary" />
          </TooltipArrowLeft>
        </div>
        <Button
          color="primary"
          className={classes.styledDisabledButtonText}
          disabled={!isEnabledUnlockCodes || !isCouponEditable}
          onClick={onSetCodesButtonClick}
        >
          SET CODES
        </Button>
      </CardContent>
    </Card>
  );
};

export default EnableUnlockCodesCard;
